import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getScheduleForReschedule = async (id, query) => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: `productivity-host/reschedule/schedule/${id}?${query}`,
  });

  return data?.data;
};

export default getScheduleForReschedule;
